import { MENU_REGISTRY } from '@app/core/state/session';
import { ItemsMenu as CentralItemsMenu } from '@app/central/data';
import { ItemsMenu as TenantItemsMenu } from '@app/tenant/data';
import { ItemsMenu as SelfManagementItemsMenu } from '@app/self-management/data';

export const navigationProviders = [
  {
    provide: MENU_REGISTRY,
    useValue: {
      central: CentralItemsMenu,
      tenant: TenantItemsMenu,
      'self-management': SelfManagementItemsMenu,
    },
  },
];
